import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  Tooltip,
  IconButton,
  useTheme,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";
import { Button } from "../../ui/forms/Button";
import { UserContext } from "../../../contexts/UserContext";
import { PatronContext } from "../../../contexts/PatronContext";
import { PaneContext } from "../../../contexts/PaneContext";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import { OrderContext } from "../../../contexts/OrderContext";

function HeaderButtons() {
  const { logout, userRole } = useContext(UserContext);
  const { selectPatron } = useContext(PatronContext);
  const { toggleNewPatronMode } = useContext(PaneContext);
  const { orders } = useContext(OrderContext);
  const navigate = useNavigate();
  const { palette } = useTheme();
  const [LogoutModal, setLogoutModal] = useState(false);

  const Logout = async () => {
    if (orders.length > 0) {
      setLogoutModal(true);
    } else {
      await logout();
      selectPatron();
    }
  };

  const logoutwithcard = async () => {
    await logout();
    selectPatron();
  };

  const access = async () => {
    window.open("https://www.monitorwa.com.au/product-category/accessories/");
  };

  return (
    <Container>
      {userRole === "admin" ? (
        <Button
          colour="error"
          onClick={() => {
            toggleNewPatronMode(false);
            navigate("/admin", { replace: true });
          }}
        >
          Admin
        </Button>
      ) : null}

      <Button style={{ marginLeft: "10px" }} onClick={access} colour="success">
        Accessories
      </Button>

      <Tooltip title="Home">
        <IconButton
          onClick={() => navigate("/dashboard", { replace: true })}
          style={{ FontSize: "50px", marginLeft: "1rem" }}
        >
          <HomeOutlinedIcon style={iconStyles} color={palette.secondary.main} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Settings">
        <IconButton
          onClick={() => {
            toggleNewPatronMode(false);
            navigate("/settings", { replace: true });
          }}
          style={{ fontSize: "30px", marginRight: "1rem" }}
        >
          <SettingsOutlinedIcon
            style={iconStyles}
            color={palette.secondary.main}
          />
        </IconButton>
      </Tooltip>
      <Tooltip title="Reports">
        <IconButton
          onClick={() => {
            toggleNewPatronMode(false);
            navigate("/reports", { repalce: true });
          }}
          style={{ fontSize: "30px", marginRight: "1rem" }}
        >
          <AssessmentOutlinedIcon
            style={iconStyles}
            color={palette.secondary.main}
          />
        </IconButton>
      </Tooltip>

      <Button
        onClick={Logout}
        startIcon={<ExitToAppOutlinedIcon />}
        colour="secondary"
      >
        LOGOUT
      </Button>

      <Dialog open={LogoutModal} onClose={() => setLogoutModal(false)}>
        <DialogContent>
          <b>
            Are you sure you want to logout.
            <br></br>
            <br></br>
          </b>
          You have queued card(s) for ordering and these card orders will not be
          <br></br> processed if you logout and the card orders will be removed
          from the order queue. <br></br>
          <br></br> To process these card orders please select the "Submit
          Order" button.
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setLogoutModal(false);
            }}
          >
            OK
          </Button>
          {/* <Button onClick={logoutwithcard}>Yes</Button> */}
        </DialogActions>
      </Dialog>
    </Container>
  );
}

const iconStyles = {
  fontSize: "35px",
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;

export default HeaderButtons;
